
<template>
  <div>
    <div class="max-w-6xl m-auto">
    <div class="flex flex-wrap mt-12 p-3">
      <div class="w-full md:w-1/3 pt-6 md:pt-24">
        <h1 class="text-4xl text-center font-semibold text-gray-800 leading-tight">
            A real-time dashboard worthy of your company's lobby
        </h1>
        <br>
        <p class="text-center">
            <button class="rounded text-white py-2 px-3 bg-green-500 shadow-md" v-on:click="view.signUpModal.show=true" v-if="!user">
                Reserve your url
            </button>
            <router-link class="rounded text-white py-2 px-3 bg-green-500 shadow-md" to="/account" v-if="user">
              My Account
            </router-link>
        </p>
        <p class="text-center text-sm my-5">
          <a href="#aboutUs">
            Built with <font-awesome-icon icon="heart" :style="{ color: 'red' }" /> by Catia and Chris
          </a>
        </p>
      </div>
      <div class="w-full md:w-2/3 md:pl-12">
        <div class="mapWrapper">
          <mapbox
            access-token="pk.eyJ1IjoiY2hpcGQiLCJhIjoiYW9sdFN1RSJ9.QHenEiJf4rDhmD9GXctdYw"
            :map-options="mapOptions"
            :nav-control="{show:false}"
            @map-load="mapLoaded">
          </mapbox>
        </div>
      </div>
    </div>

    <section>
      <div class="flex flex-wrap mt-24">
        <h3 class="text-center text-4xl text-gray-800 w-full">
          What is livedata.ninja?
        </h3>
        <div class="w-2/3 m-auto md:w-1/2">
          <p class="text-center mt-6 leading-relaxed">
            A slick, real-time dashboard to put on your startup's wall-mounted televisions to show off what's happening in your startup <span class="is-italic">right now</span>. 
            <br>
            <br>
            Why? Because seeing your company's work happening in real time, affecting people's lives - that's cool.
          </p>
        </div>
      </div>
    </section>

    <!-- INTEGRATIONS?? -->
    <!-- DEMO DASHBOARDS?? -->

    <section>
      <div class="flex flex-wrap mt-24">
        <h3 class="text-center text-4xl text-gray-800 w-full">
          How it works
        </h3>
        <div class="w-2/3 m-auto md:w-1/2">
          <p class="text-center mt-6 leading-relaxed">
            You get an endpoint to send data to that will render on your dashboard in real-time. It's that simple
          </p>
        </div>
      </div>
    </section>


    <section id="aboutUs">
      <div class="flex flex-wrap mt-24">
        <h3 class="text-center text-4xl text-gray-800 w-full">
          Built by Catia and Chris
        </h3>
        <div class="w-full md:w-1/2 mt-6">
          <figure class="image">
            <img class="m-auto md:mr-0 rounded-full shadow-lg" src="@/assets/chriscat.jpg" width="300">
          </figure>
        </div>
        <div class="w-3/4 md:w-1/3 md:ml-0 p-5 m-auto text-center md:text-left leading-relaxed">
          <p>Catia takes care of backend and database, Chris focuses on frontend. Together we want to build a product from scratch that provides real value to the world. We both have 9-5's, and our dream is that livedata.ninja can grow to the point where it's our primary source of income :) </p>
        </div>
      </div>
    </section>

    <div class="modal fixed w-full h-full" id="signupModal" v-if="view.signUpModal.show">
        <div class="modal-background" @click="view.signUpModal.show=false"></div>
        <div class="modal-content">
            <p class="text-xl is-grey text-center">Sign Up</p>
            <form @submit="signUpUser" id="signupForm" action="#">
                <div class="mb-3">
                  <input name="email" class="input text-center w-full py-1 rounded" type="text" placeholder="email" autocomplete="email" required v-model="userEmail">
                </div>
                <div class="mb-3">
                  <input name="password" class="input text-center w-full py-1 rounded" type="password" autocomplete="new-password" placeholder="password" value="" required minlength="8" v-model="userPassword">
                    <p class="text-gray-500 block text-sm mt-2 text-center">min 8 characters</p>
                </div>
                <div class="">
                    <div class="control" style="display: flex;align-items: center;">
                        <span class="is-size-6">livedata.ninja/dash/</span>
                        <input name="url" class="input py-1 rounded" type="text" placeholder="your unique URL" value="" required v-model="userDashboardName" v-on:input="checkDashUrl" style="padding-left: 4px;">
                    </div>
                    <p v-if="view.dashCheck.show && view.dashCheck.isLoading && userDashboardName.length > 0" class="text-gray-700 block text-sm mt-2 text-center">Checking URL</p>
                    <div v-if="!view.dashCheck.isLoading">
                      <p v-if="this.userDashboardName.length < 4 && this.userDashboardName.length > 0" class="text-gray-700 block text-sm mt-2 text-center">Must be at least 4 characters</p>
                      <p v-if="view.dashCheck.show && view.dashCheck.isAvailable" class="text-center text-sm text-green-600 mt-2">URL is available!</p>
                      <p v-if="view.dashCheck.show && !view.dashCheck.isLoading && !view.dashCheck.isAvailable" class="text-center text-red-500 mt-2 text-sm">URL is taken :(</p>
                    </div>
                </div>
                <div class="mt-5 text-center">
                  <button class="rounded text-white py-2 px-3 bg-green-500 shadow-md" :class="{'disabled': view.signUpModal.isLoading}">Sign up and reserve</button>
                  <p v-if="view.signUpModal.error" class="text-center text-red-500 mt-2 text-sm">{{view.signUpModal.error}}</p>
                </div>
            </form>
        </div>
    </div>



    <div style="display: none;">
      <img src="@/assets/redDot.png" ref="marker"  alt="" width="20">
    </div>
  </div>
  
</div>
</template>


<script>
let sampleHits = [{
    "title": "Sale! $249",
    "description": "Paris, FR",
    "position": {
      "lat": 2.3522,
      "lon": 48.8566
    }
  }, 
  {
    "title": "New Order! $75.99",
    "description": "Brooklyn, NY",
    "position": {
      "lat": -73.9442,
      "lon": 40.6782
    }
  },
  {
    "title": "New Signup!",
    "description": "Dublin, IE",
    "position": {
      "lat": -6.2603,
      "lon": 53.3498
    }
  }
];

import Mapbox from 'mapbox-gl-vue';

let mapboxgl = window.mapboxgl;

export default {
  name: 'Home',
  components: {
    Mapbox
  },
  props: {
    msg: String
  },
  data: function(){
    return {
      map: null,
      mapOptions: {
        container: 'homepageMap',
        style: 'mapbox://styles/chipd/cjvckrf590dcr1fkq876thply',
        center: [0, 11],
        zoom: 2,
        minZoom: 1.5
      },
      view: {
        signUpModal: {
          show: false,
          error: null,
          isLoading: false
        },
        dashCheck: {
          isAvailable: false,
          isLoading: false,
          show: false
        }
      },
      userEmail: "",
      userPassword: "",
      userDashboardName: "",
      testCount: 0,
      currentController: null,
      loopInterval: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    }
  },
  mounted: function(){

  },
  beforeDestroy() {
    // console.log("before destroy running");
    // if we don't remove the map we'll get that all black map
    this.map.remove();
  },
  beforeRouteLeave (to, from, next) {
      // called when the route that renders this component is about to
      // be navigated away from.
      // has access to `this` component instance.
      console.log("removing loopInterval")
      if(this.loopInterval){
        clearInterval(this.loopInterval)
      }
      next()
  },
  methods: {
    subscribeUser(email){
      let obj = {
        "email": email
       }
      fetch('/api/subscribe/mailchimp', {
          method: 'post',
          body: JSON.stringify(obj),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(response=>{
          return response.json();
        })
        .then(data=>{
          // console.log("user subscribed data:", data)
          if(data.error){
            throw data.error
          } else {
            // user subscribed successfully
          }
        })
        .catch(()=>{
          // console.log("err subscribing user:", err);
        })
    },
    mapLoaded(map) { 
      this.map = map;
      this.startLoops();
    },
    signUpUser(e){

      e.preventDefault();

      this.view.signUpModal.isLoading = true

      // subscribe user
      this.subscribeUser(this.userEmail);

      let newUser = {
        "email": this.userEmail,
        "password": this.userPassword,
        "dashboardName": this.userDashboardName
      }

      // console.log("newUser wants to sign up:", newUser);
      // if they haven't selected an available URL
      // Don't let them submit the form
      // show them an error
      if(!this.view.dashCheck.isAvailable || this.view.dashCheck.isLoading){
        this.view.signUpModal.error = "Select an available URL for your dashboard"
        return
      }

      this.$store
        .dispatch('signUp',newUser)
        .then(response=>{
          console.log('user created:', response);
          this.$router.replace(`/dash/${response.dashboardName}`)
        }) 
        .catch(err=>{
          this.view.signUpModal.error = err.message
        })
        .finally(()=>{
          this.view.signUpModal.isLoading = false
        })

    },
    checkDashUrl(){

      let name = encodeURI(this.userDashboardName.toLowerCase())

      // cancel if no name, or name too short (user emptied input)
      if(name.length < 4){
        return this.view.dashCheck.show = false
      }
      // when the user enters a dashboard name
      // check to see if it's available
      // show input text, show it's loading
      this.view.dashCheck.isLoading = true;
      this.view.dashCheck.show = true;

      // abort previous one if it exists
      if(this.currentController){
        // console.log("cancelling request");
        this.currentController.abort()
      }

      this.currentController = new AbortController()
      let signal = this.currentController.signal

      fetch(`/api/check/dashboard-name?dashboardName=${name}`, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              signal: signal
            })
        .then(function(response) {
          return response.json()
        })
        .then(data=>{
          // console.log("message:", data.message);
          if(data.message == "Url available!"){
            this.view.dashCheck.isAvailable = true
          } else {
            this.view.dashCheck.isAvailable = false
          }

          // show message, disable loading
          this.view.dashCheck.isLoading = false
          this.view.dashCheck.show = true
        })
        .catch(err=>{
          if(err=="AbortError: The user aborted a request."){
            console.log('request aborted')
          } else {
            console.log("error checking dashname: "+err);
          }
        })
    },
    clearPopup(popup) {
      setTimeout(() => {
          popup.remove();
      }, 5000)
    },
    addTestPoint(point){
      
      // fly to that point
      this.map.flyTo({
        center: [point.position.lat, point.position.lon],
        zoom: 6,
        speed: 1,
        curve: 1.5
      });

      let popupHtml = `
        <h1 class="text-lg text-center">${point.title}</h1>
        <p class="text-sm text-gray-700 text-center">${point.description}</p>
      `

      let popup = new mapboxgl.Popup({ closeOnClick: false })

      popup
          .setLngLat([point.position.lat, point.position.lon])
          .setHTML(popupHtml)
          .addTo(this.map);

      let element = this.$refs.marker.cloneNode(true)

      let markerOptions = {
          element: element,
          anchor: 'center'
      }

      let marker = new mapboxgl.Marker(markerOptions)
      
      marker
        .setLngLat([point.position.lat, point.position.lon])
        .addTo(this.map);

      // this.clearPopup(popup);
    },

    startLoops(){
      // console.log("starting points loop every 7s");

      // render first point straight away
      this.addTestPoint(sampleHits[0])

      // increment counter
      this.testCount++

      // start interval loop
      this.loopInterval = setInterval(()=>{

        // add point to map
        this.addTestPoint(sampleHits[this.testCount])

        if(this.testCount == sampleHits.length -1){
          // console.log('resetting this.testCount and stopping loop')
          this.testCount = 0
          clearInterval(this.loopInterval)
        } else {
          // console.log('incrementing this.testCount')
          this.testCount++
        }
      }, 7000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .marker {
      background-image: url('../assets/redDot.png');
      background-size: cover;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      cursor: pointer;
    }

    .hero-foot {
      margin: 50px 0;
    }

    #homepageMap { 
        width: 100%;
        height:450px;
        box-shadow: 0 0 15px 15px #f3f3f3;
        border-radius: 5px;
        max-width:100%;
    }

    /* Close button in popup */
    .mapboxgl-popup-close-button {
      display:none;
    }

    .mapboxgl-canvas { position: relative !important; left:0; }
    .mapboxgl-canvas:focus, .mapboxgl-canvas:active, .mapboxgl-canvas:visited, .mapboxgl-canvas:focus-within {outline: none;}
    .mapboxgl-ctrl-bottom-left, .mapboxgl-ctrl-bottom-right { display:none; }

    .mapboxgl-popup-content {
        box-shadow: 0 1px 10px 1px rgba(49, 49, 49, 0.67);
        padding: 15px 17px;
    }
    #aboutUs {
      min-height: 500px;
    }

    #aboutUs img {
      width: 300px;
      max-width:90%;
      border: 0;
      box-shadow: 0 3px 10px 4px #e0e0e0;
    }

    .sample-dash {
      height: 150px;
    }

    .disabled {
      @apply opacity-50 cursor-not-allowed;
    }

</style>
